<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="880px"
    :show-close="true"
    title="上传水单"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :before-close="cancel"
  >
    <div class="box">
      <div class="step">
        <div class="step-item" :class="{ active: active > 0 }">
          <svg-icon iconClass="num-1" className="icon" />
          {{ !typeActive ? "选择客户" : "选择供应商" }}
        </div>
        <svg-icon
          iconClass="arrow"
          className="icon"
          :class="{ active: active > 1 }"
        />
        <div class="step-item" :class="{ active: active > 1 }">
          <svg-icon iconClass="num-2" className="icon" />
          填写水单信息
        </div>
        <svg-icon
          iconClass="arrow"
          className="icon"
          :class="{ active: active > 1 }"
        />
        <div class="step-item" :class="{ active: active > 2 }">
          <svg-icon iconClass="num-3" className="icon" />
          上传附件
        </div>
      </div>
      <div v-show="active === 1">
        <div>
          <template v-if="!typeActive">
            <div class="glasstitle">请选择客户：</div>
            <el-select
              v-model="companyId"
              style="width: 320px;margin-top: 32px;
              margin-left: 95px;
          }"
              filterable
              placeholder="请选择客户"
            >
              <el-option
                v-for="item in companyDrapdown"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
          <template v-if="typeActive">
            <div class="glasstitle">请选择供应商：</div>
            <el-select
              v-model="supplierId"
              style="width: 320px;margin-top: 32px;
              margin-left: 95px;
          }"
              filterable
              placeholder="请选择供应商"
            >
              <el-option
                v-for="item in supplierOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </div>
      </div>
      <div v-show="active === 2">
        <el-form ref="form" :model="form" :rules="rules" class="formmain">
          <div class="bank">
            <label class="label"><span class="red">*</span> 收款账号</label>
            <div class="bank-select" @click="add">
              <template v-if="!supplyItem.id">
                <svg-icon className="icon1" iconClass="add" />
                <span class="add">选择账号</span>
              </template>
              <template v-if="supplyItem.id">
                <div class="panle">
                  <div class="left">
                    <svg-icon
                      className="icon"
                      :iconClass="supplyItem.iconClass"
                    />
                    <div class="content">
                      <p class="bank-name">
                        {{ supplyItem.bankName }}
                        <span :class="supplyItem.currency.toUpperCase()">{{
                          supplyItem.currency.toUpperCase()
                        }}</span>
                      </p>
                      <p class="bank-name">{{ supplyItem.bankBranchName }}</p>
                      <p class="bank-number">{{ supplyItem.accountNumber }}</p>
                      <p class="address">{{ supplyItem.accountName }}</p>
                    </div>
                  </div>
                  <div class="right">
                    <span class="change-account" @click="add">更换账号</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div>
            <el-form-item label="付款账户名" prop="paymentAccountName">
              <el-input
                v-model="form.paymentAccountName"
                style="width: 320px"
                placeholder="请输入付款账户名"
              ></el-input>
            </el-form-item>
            <el-form-item label="金额" prop="sourceAmount">
              <el-input-number
                v-model="form.sourceAmount"
                style="width: 100%"
                controls-position="right"
                :min="0.01"
                :precision="2"
                @change="sourceAmountChange"
              ></el-input-number>
            </el-form-item>
          </div>
          <el-form-item label="币制" prop="sourceCurrency">
            <el-select
              v-model="form.sourceCurrency"
              style="width: 320px"
              placeholder="请选择计算方式"
              disabled
              @change="currencyChange"
            >
              <el-option
                v-for="item in currencyOption"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="汇率" prop="exchangeRate">
            <el-input
              v-model="form.exchangeRate"
              disabled
              style="width: 320px"
            ></el-input>
          </el-form-item>
          <el-form-item label="结算币制" prop="realCurrency">
            <el-input
              v-model="form.realCurrency"
              style="width: 320px"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="实际金额" prop="realAmount">
            <el-input
              v-model="form.realAmount"
              style="width: 320px"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="description">
            <el-input
              v-model="form.description"
              style="width: 675px"
              placeholder="请填写备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="active === 3">
        <div class="view-upload">
          <el-upload
            class="upload-demo"
            drag
            :action="`/api/SystemFile/uploadFile?source=2`"
            :headers="header"
            :multiple="false"
            :file-list="fileList"
            :show-file-list="false"
            :data="{ source: 2 }"
            :on-success="handlesuccess"
            :on-error="onError"
            :on-progress="handlePreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :limit="1"
            :before-upload="beforeUpload"
          >
            <svg-icon iconClass="upload" className="icon" />
            <div class="btn">选择文件</div>
            <p class="el-upload__text">只支持图片格式上传</p>
          </el-upload>
          <div class="file-list">
            <div v-for="(item, $index) in fileList" :key="$index" class="panle">
              <div class="left">
                <img
                  src="@/assets/images/const/constwiimg.png"
                  width="32"
                  height="32"
                />
                <div class="file">
                  <p class="file-name">{{ item.name }}</p>
                  <p class="file-size">
                    {{ item.size | formatterSize }} MB
                    <el-progress
                      style="width: 260px; margin-left: 20px"
                      :width="220"
                      :percentage="percentage"
                    ></el-progress>
                  </p>
                </div>
              </div>
              <div class="right">
                <i class="el-icon-delete gou" @click="removeFiles" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="footers">
      <div v-show="active !== 1" class="cancel flex_c_c" @click="propbtn">
        上一步
      </div>
      <div v-show="active === 1" class="cancel flex_c_c" @click="propbtn">
        取消
      </div>
      <div v-show="active !== 3" class="ok flex_c_c" @click="submit('form')">
        下一步
      </div>
      <div v-show="active === 3" class="ok flex_c_c" @click="submit">完成</div>
    </span>
    <select-company-bank-dialog
      :dialogVisible="dialogVisible2"
      :companyId="companyId"
      :supplierId="supplierId"
      :typeActive="typeActive"
      @ok="ok2"
      @cancel="cancel2"
    ></select-company-bank-dialog>
  </el-dialog>
</template>
<script>
import SelectCompanyBankDialog from './SelectCompanyBankDialog.vue'
import { getCurrency, getExchangeRate } from '@/api/fee'
import { addPayment } from '@/api/client'
import { addPaymentBySupplier } from '@/api/supplierPayment'
import config from '@/utils/config'
import { mapGetters } from 'vuex'
export default {
  components: { SelectCompanyBankDialog },
  filters: {
    formatterSize(size) {
      return (size / 1024 / 1024).toFixed(2)
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    typeActive: {
      type: Number,
      default: 0
    },
    supplierOptions: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      code: '',
      config,
      fileList: [],
      active: 1,
      supplyItem: {},
      companyId: '',
      supplierId: '',
      form: {
        paymentAccountName: '',
        realCurrency: '',
        sourceCurrency: '',
        sourceAmount: '',
        exchangeRate: '',
        realAmount: '',
        description: ''
      },
      rules: {
        sourceCurrency: [
          {
            required: true,
            message: '请选择币制',
            trigger: 'change'
          }
        ],
        realCurrency: [
          {
            required: true,
            message: '请选择币制',
            trigger: 'change'
          }
        ],
        realAmount: [
          {
            required: true,
            message: '请输入金额',
            trigger: 'blur'
          }
        ],
        sourceAmount: [
          {
            required: true,
            message: '请输入金额',
            trigger: 'blur'
          }
        ],
        exchangeRate: [
          {
            required: true,
            message: '请输入汇率',
            trigger: 'blur'
          }
        ],
        paymentAccountName: [
          {
            required: true,
            message: '请输入付款账户名',
            trigger: 'blur'
          }
        ]
      },
      currencyOption: [],
      uploadData: {},
      dialogVisible2: false,
      supplySelect: 0,
      percentage: 0,
      systemFileId: '',
      header: { 'ESCLEARANCE': btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`) }
      // companyInfo: ''
    }
  },
  computed: {
    ...mapGetters(['selectSupply', 'companyDrapdown'])
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getCurrencyList()
        this.active = 1
        this.$refs['form']?.resetFields()
      }
    }
  },
  async mounted() {},
  methods: {
    async getCurrencyList() {
      const res = await getCurrency({
        identityCode: this.identityCode
      })
      if (res.success) {
        this.currencyOption = res.data
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // async getCompany() {
    //   try {
    //     const res = await getCompanyDetail({
    //       id: this.companyId
    //     })
    //     if (res.success) {
    //       this.companyInfo = res.data
    //     } else {
    //       this.$message.error(res.errorMessage)
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    currencyChange(val) {
      if (
        val.toUpperCase() !== this.form.realCurrency.toUpperCase() &&
        this.form.realCurrency
      ) {
        const params = {
          sourceCurrency: val,
          destinationCurrency:
            this.form.realCurrency.toUpperCase() === 'RMB'
              ? val
              : this.form.realCurrency
        }
        this.getCurrencyExchangeRate(params)
      }
    },
    getCurrencyExchangeRate(params) {
      getExchangeRate({
        type: 0,
        ...params
      }).then((res) => {
        console.log(res)
        if (res.success) {
          this.form.exchangeRate = res.data.rateValue
          if (this.form.sourceAmount) {
            this.getRealAmount()
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    sourceAmountChange() {
      if (this.form.exchangeRate) {
        this.getRealAmount()
      }
    },
    getRealAmount() {
      if (this.form.realCurrency.toUpperCase() === 'RMB') {
        this.form.realAmount = (
          this.form.sourceAmount * this.form.exchangeRate
        ).toFixed(2)
      } else {
        this.form.realAmount = (
          this.form.sourceAmount / this.form.exchangeRate
        ).toFixed(2)
      }
    },
    removeFiles() {
      this.fileList = []
    },
    propbtn() {
      if (this.active === 1) {
        this.$emit('cancel')
        this.supplyItem = {}
        this.fileList = []
        this.$refs['form'].resetFields()
      } else {
        this.active--
      }
    },
    cancel() {
      this.$emit('cancel')
      this.active = 1
      this.supplyItem = {}
    },
    submit(formName) {
      switch (this.active) {
        case 1:
          this.active = 2
          break
        case 2:
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (!this.supplyItem.id) {
                this.$message.warning('请选择收款账号')
                return
              }
              this.active = 3
            }
          })
          break
        case 3:
          this.submitBill()
          break
      }
    },
    async submitBill() {
      try {
        const params = {
          suppilerCode: this.config.supplyCode,
          bankAccountNumber: this.supplyItem.accountNumber,
          systemFileId: this.systemFileId,
          ...this.form,
          companyId: this.companyId,
          supplierId: this.supplierId,
          realAmount: parseFloat(this.form.realAmount),
          sourceAmount: parseFloat(this.form.sourceAmount)
        }
        let res
        if (!this.typeActive) {
          res = await addPayment(params)
        } else {
          res = await addPaymentBySupplier(params)
        }
        if (res.success) {
          this.$message.success('新增成功')
          this.$refs['form']?.resetFields()
          this.$emit('ok')
          this.supplyItem = {}
          this.fileList = []
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleRemove() {
      this.fileList = []
      this.systemFileId = ''
    },
    beforeUpload(file) {
      const types = ['image/jpeg', 'image/jpg', 'image/png']
      const isImage = types.includes(file.type)
      if (!isImage) {
        this.$message.error('只能上传图片')
        return false
      }
      this.fileList.push(file)
    },
    handlePreview(event, file) {
      this.percentage = file.percentage
    },
    handlesuccess(response, file, fileList) {
      console.log(response, file, fileList)
      if (response.success) {
        this.systemFileId = response.data.id
        this.percentage = 100
      } else {
        this.$message.error(response.errorMessage)
        this.fileList = []
        this.systemFileId = ''
      }
    },
    handleExceed() {
      this.$message.warning('只允许上传一个文件，请删除后再上传')
    },
    onError(err, file, fileList) {
      console.log(err, file, fileList)
    },
    add() {
      this.dialogVisible2 = true
    },
    ok2(item) {
      let currency
      if (!this.typeActive) {
        currency = this.companyDrapdown.find(
          (a) => a.id === this.companyId,
        ).currency
      } else {
        currency = item.currency
      }
      this.supplyItem = item
      this.form.sourceCurrency = item.currency
      this.form.realCurrency = currency
      if (item.currency !== this.form.realCurrency && this.form.realCurrency) {
        const params = {
          sourceCurrency: item.currency,
          destinationCurrency:
            this.form.realCurrency.toUpperCase() === 'RMB'
              ? item.currency
              : this.form.realCurrency
        }
        this.getCurrencyExchangeRate(params)
      } else {
        this.form.exchangeRate = 1
        this.getRealAmount()
      }
      this.cancel2()
    },
    cancel2() {
      this.dialogVisible2 = false
    }
  }
}
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  // height: 355px;
  margin-bottom: 20px;

  .step {
    position: absolute;
    left: 50%;
    top: 9px;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 480px;
    background: #f8fbff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #f2f7ff;
    box-sizing: border-box;
    color: #b8c3de;
    .icon {
      font-size: 14px;
    }
    .active {
      color: rgb(18, 88, 188);
    }
    .step-item {
      width: auto;
      height: 100%;
      text-align: center;
      line-height: 40px;
    }
  }
  .formmain {
    margin-left: 100px;
    width: 675px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .bank {
    width: 320px;
    background: #fff;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
  }
  .label {
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #25396f;
    line-height: 40px;
  }
  .red {
    color: #ff7444;
  }
  .bank-select {
    width: 320px;
    height: 124px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #dbe4f2;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .panle {
      width: calc(100% - 32px);
      height: 90px;
      background: #f8fbff;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      padding: 16px;
      justify-content: space-between;
      display: flex;
      position: relative;
      & + .panle {
        margin-top: 8px;
      }
    }
    .left {
      display: flex;
    }
    .bank-name {
      height: 16px;
      font-size: 12px;
      font-weight: 400;
      color: #7c8db5;
      line-height: 16px;
    }
    .bank-number {
      margin-top: 8px;
      height: 26px;
      font-size: 20px;
      font-weight: 400;
      color: #25396f;
      line-height: 26px;
    }
    .address {
      height: 16px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #7c8db5;
      line-height: 24px;
    }
    .RMB {
      width: 27px;
      height: 16px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #fe453d;
      line-height: 16px;
      padding: 2px 4px;
      background: rgba(254, 69, 61, 0.1);
      border-radius: 4px 4px 4px 4px;
      margin-left: 10px;
    }
    .USD {
      width: 27px;
      height: 16px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #35ba83;
      line-height: 16px;
      padding: 2px 4px;
      background: rgba(53, 186, 131, 0.1);
      border-radius: 4px 4px 4px 4px;
      margin-left: 10px;
    }
    .icon {
      font-size: 32px;
      margin-right: 8px;
    }
    .change-account {
      height: 16px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      line-height: 16px;
      position: absolute;
      width: 48px;
      right: 16px;
    }
  }
  .icon1 {
    font-size: 20px;
    color: rgb(18, 88, 188);
  }
  .add {
    width: 56px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    line-height: 19px;
    margin-left: 5px;
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  & div {
    width: 120px;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #f2f7ff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dbe4f2;
    color: #7c8db5;
    margin-right: 16px;
    box-sizing: border-box;
  }
  .ok {
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    color: #ffffff;
  }
}
.glassbox {
  display: flex;
  justify-content: center;
  .glassbtn {
    width: 120px;
    z-index: 100;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 0px 6px 6px 0px;
    opacity: 1;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
.glasstitle {
  margin-top: 32px;
  margin-left: 95px;
  width: 98px;
  height: 19px;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #25396f;
  line-height: 24px;
}
.suplieimg {
  width: 710px;
  height: auto;
  min-height: 100px;
  margin-left: 95px;
  margin-top: 15px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .imgbox {
    margin-top: 10px;
    width: 160px;
    height: 40px;
    margin-right: 15px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #dbe4f2;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  img {
    max-height: 40px;
    max-width: 160px;
    object-fit: contain;
  }
  .imgselect {
    border: 1px solid rgb(18, 88, 188);
    position: relative;
  }
  .imgselect::before {
    position: absolute;
    content: "\2714";
    top: 0;
    right: 0;
    color: white;
    width: 0px;
    height: 0px;
    border-top: 27px solid rgb(18, 88, 188);
    border-left: 24px solid transparent;
  }
}
.view-upload {
  width: 586px;
  margin: 0 auto;
  height: auto;
  .upload-demo {
    width: 100%;
    height: 320px;
  }
  &:deep(.el-upload) {
    width: 100%;
    height: 320px;
  }
  &:deep(.el-upload-dragger) {
    width: 100%;
    height: 320px;
  }
  &:deep(.el-upload-dragger) {
    background: #f8fbff;
    border: 0;
  }
  &:deep(.el-upload__text) {
    width: 100%;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #b8c3de;
    line-height: 24px;
    margin-top: 10px;
  }
  .btn {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid rgb(18, 88, 188);
    margin: 10px auto 0;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    line-height: 40px;
  }
  .file-list {
    width: 100%;
    height: auto;
    margin-top: 20px;
    .left {
      display: flex;
      align-items: center;
      width: calc(100% - 16px);
    }
    .panle {
      width: calc(100% - 48px);
      height: 40px;
      padding: 12px 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.1);
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
    }
    .file {
      margin-left: 15px;
      width: 100%;
      .file-name {
        width: 100%;
        height: 19px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 19px;
      }
      .file-size {
        display: flex;
        height: 16px;
        width: 100%;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 16px;
        margin-top: 4px;
      }
    }
    .gou {
      font-size: 24px;
      color: #b8c3de;
      cursor: pointer;
    }
  }
  .icon {
    font-size: 60px;
    color: rgb(18, 88, 188);
    margin-top: 85px;
  }
  .icon1 {
    font-size: 40px;
    color: rgb(18, 88, 188);
  }
}
</style>
